'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractData = undefined;

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var extractData = exports.extractData = function extractData(response) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'data';

  var error = (0, _get2.default)(response, 'data.errors.0.message');
  if (error) return Promise.reject(error);

  return (0, _get2.default)(response, path);
};